import { makeAutoObservable } from 'mobx'
import { Cause } from '../../types/models/Cause'
import { Device } from '../../types/models/Device'
import { Issue } from '../../types/models/Issue'
import { Location } from '../../types/models/Locations'
import { User } from '../../types/models/User'
import { Role } from '../../types/models/Role'
import { Place } from '../../types/models/Place'
import { Unit } from '../../types/models/Unit'
import { Material } from '../../types/models/Material'
import { Order } from '../../types/models/Order'
import { UsersTG } from '../../types/models/UsersTG'

export class ModalsUi {
  editUser = false
  user: User | undefined

  editRole = false
  role: Role | undefined

  editUnit = false
  unit: Unit | undefined

  editMaterial = false
  material: Material | undefined

  editPlace = false
  place: Place | undefined

  editDevice = false
  device: Device | undefined

  generateQR = false
  deviceQR: Device | undefined

  editCauses = false
  cause: Cause | undefined
  causes: Cause[] = []

  editLocation = false
  location: Location | undefined

  editIssue = false
  endIssueWork = false
  compliteIssueWork = false
  issue: Issue | undefined

  editOrder = false
  endOrderWork = false
  completeOrder = false
  order: Order | undefined

  keyToUser: any | undefined

  locationId: number | undefined
  locationPath: string | undefined

  editUsersTG = false
  userstg: UsersTG | undefined
  
  createUser = false
  createRole = false
  createUnit = false
  createMaterial = false
  createPlace = false
  сreateDevices = false
  createLocation = false
  createCauses = false
  createIssue = false
  createOrder = false
  createUsersTG = false

  constructor() {
    makeAutoObservable(this)
  }

  hundleEditUser(open: boolean, user?: User) {
    this.editUser = open
    this.user = user
  }

  hundleEditUsersTG(open: boolean, userstg?: UsersTG) {
    this.editUsersTG = open
    this.userstg = userstg
  }

  hundleEditRole(open: boolean, role?: Role) {
    this.editRole = open
    this.role = role
  }

  hundleEditUnit(open: boolean, unit?: Unit) {
    this.editUnit = open
    this.unit = unit
  }
  
  hundleEditMaterial(open: boolean, material?: Material) {
    this.editMaterial = open
    this.material = material
  }

  hundleEditPlace(open: boolean, place?: Place) {
    this.editPlace = open
    this.place = place
  }

  hundleEditDevice(open: boolean, device?: Device) {
    this.editDevice = open
    this.device = device
  }

  hundleEditCauses(open: boolean, cause?: Cause) {
    this.editCauses = open
    this.cause = cause
  }

  hundleEditLocation(open: boolean, location?: Location) {
    this.editLocation = open
    this.location = location
  }

  hundleEditIssue(open: boolean, issue?: Issue) {
    this.editIssue = open
    this.issue = issue
  }

  hundleEndIssueWork(open: boolean, issue?: Issue) {
    this.endIssueWork = open
    this.issue = issue
  }

  hundleCompliteIssueWork(open: boolean, issue?: Issue) {
    this.compliteIssueWork = open
    this.issue = issue
  }

  hundleCreateIssue(open: boolean, device?: Device) {
    this.createIssue = open
    this.device = device
  }

  hundleEditOrder(open: boolean, order?: Order) {
    this.editOrder = open
    this.order = order
  }

  hundleEndOrderWork(open: boolean, order?: Order) {
    this.endOrderWork = open
    this.order = order
  }

  hundleCompleteOrder(open: boolean, order?: Order) {
    this.completeOrder = open
    this.order = order
  }

  hundleCreateOrder(open: boolean, material?: Material, path?: string) {
    this.createOrder = open
    this.material = material
    this.locationPath = path
  }

  hundleCreateUser(open: boolean) {
    this.createUser = open
  }

  hundleCreateRole(open: boolean) {
    this.createRole = open
  }

  hundleCreateUnit(open: boolean) {
    this.createUnit = open
  }
  
  hundleCreateMaterial(open: boolean) {
    this.createMaterial = open
  }

  hundleCreatePlace(open: boolean, locationId?: number) {
    this.createPlace = open
    this.locationId = locationId
  }

  hundleCreateDevices(open: boolean, locationId?: number) {
    this.сreateDevices = open
    this.locationId = locationId
  }

  hundleCreateUsersTG(open: boolean, locationId?: number) {
    this.createUsersTG = open
    this.locationId = locationId
  }

  hundleCreateLocation(open: boolean, locationId?: number) {
    this.createLocation = open
    this.locationId = locationId
  }

  hundleCreateCauses(open: boolean, cause?: Cause) {
    this.createCauses = open
    this.cause = cause
  }

  hundleSetCauses(causes: Cause[]) {
    this.causes = causes
  }

  hundleSetAddKeyToUser(key?: string) {
    this.keyToUser = key
  }

  hundleGenerateQR(open: boolean, device?: Device) {
    this.generateQR = open
    this.deviceQR = device
  }
}
